import React, { useEffect, useState, useContext } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import WaiterForm from './WaiterForm'
import mWaiter from './Waiter.controller'
import AuthContext from '../../context/auth-context'
import { isArray } from 'util'
import validate from 'validate.js'
import DialogInfo from '../../Dialog/DialogInfo'
import { Spinner } from 'react-bootstrap'

const WaiterDetail = (props) => {
    const defaultPage = parseInt(props.match.params.page, 10);
    const defaultrowsPerPage = parseInt(props.match.params.rowsPerPage, 10);
    const kodeoutlet = props.match.params.kodeoutlet;
    const kodewaiter = props.match.params.kodewaiter;
    const { clientID, token } = useContext(AuthContext)
    const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    const [dialogtext, setDialogtext] = useState()
    const [dialogUrl, setDialogUrl] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const validateForm = () => {
        const { namawaiter } = state;
        const promKategori = new Promise((resolve, reject) => {
            const constraint = {
                namawaiter: {
                    length: {
                        minimum: 3,
                        message: "Nama Waiter minimal terdiri dari 3 huruf"
                    },
                }
            }
            const validator = validate({ namawaiter }, constraint, { fullMessages: false });
            if (validator === undefined) {
                resolve();
            } else {
                reject(validator);
            }
        })
        return Promise.all([promKategori]);
    }
    const handleSimpan = () => {
        setIsLoading(true)
        validateForm().then(() => {
            mWaiter.updateWaiter(kodeoutlet, kodewaiter, state.namawaiter, clientID, token).then(resp => {
                setIsLoading(false)
                if (resp) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${state.namawaiter} berhasil di update<p/>`)
                    setDialogUrl(`/manajemenoutlet/${kodeoutlet}/waiter/${defaultPage}/${defaultrowsPerPage}`)
                } else {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Server tidak dapat menjalankan perintah Anda saat ini. Silakan coba sesaat lagi<p/>`)
                }
            }).catch(err => {
                setIsLoading(false)
                if (isArray(err) && err.length > 0) {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>Gagal Simpan : ${err[0].message}<p/>`)
                } else if (typeof err == 'error') {
                    setOpenConfirmInfo(true)
                    setDialogtext(`<p>${err.message}<p/>`)
                } else {
                    console.log(err);
                }
            })
        }).catch(err => {
            setIsLoading(false)
            const keys = Object.keys(err);
            var errorMessage = "";
            for (const key of keys) {
                errorMessage += err[key] + "\n";
            }
            setOpenConfirmInfo(true)
            setDialogtext(`<p>${errorMessage}<p/>`)
        })
    }
    const [state, setState] = useState({ kodewaiter: '', namawaiter: '' })
    useEffect(() => {
        var render = true;
        if (kodeoutlet && kodewaiter) {
            mWaiter.loadDetail(kodeoutlet, kodewaiter, clientID, token).then(resp => {
                if (render) setState(resp);
            })
        }
        return () => {
            render = false;
        };
    }, [kodeoutlet, kodewaiter, clientID, token])


    const handleChange = (key, value) => {
        const newState = Object.assign({}, state);
        newState[key] = value;
        setState(newState);
    }
    if (isLoading) {
        return <Spinner className="spinner" animation="border" />;
    } else {
        return (
            <Container>
                <WaiterForm type="edit" history={props.history} kodeoutlet={kodeoutlet} kodewaiter={state.kodewaiter} namawaiter={state.namawaiter} handleChange={handleChange} defaultPage={defaultPage} defaultrowsPerPage={defaultrowsPerPage} />
                <Row style={{ marginTop: 20, marginBottom: 20 }}>
                    <Col xs={12} className="text-center">
                        <Button variant="contained" color="primary" onClick={handleSimpan}>Update</Button>
                    </Col>
                </Row>
                <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} url={dialogUrl} redirect={props.history.push} />
            </Container>
        )
    }
}

export default WaiterDetail;